import React from "react"
import memoize from "memoize-one"
import { ThemeProvider, StyledEngineProvider, createTheme } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import customTheme from "../styles/customTheme"

const memoizedMuiTheme = memoize(createTheme)

class PbgThemeProvider extends React.Component {
  render() {
    const muiTheme = memoizedMuiTheme(customTheme)
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiTheme}>
          <CssBaseline />
          {this.props.children}
        </ThemeProvider>
      </StyledEngineProvider>
    )
  }
}

export default PbgThemeProvider
